(function(api) {
	api.InvenSObrisi = InvenSObrisi;
	api.InvenSPronadeno = InvenSPronadeno;
	api.InvenSZaRashod = InvenSZaRashod;
	api.InvenSBrojPronadenihZaFilter = InvenSBrojPronadenihZaFilter;
	api.InvenSPronadenoFilter = InvenSPronadenoFilter;
	api.SredByBarkod = SredByBarkod;
	api.SredByInvBroj = SredByInvBroj;
	api.OsZaduziById = OsZaduziById;
	api.SredStById = SredStById;
	api.InvensPostoji = InvensPostoji;
	api.SredById = SredById;
	api.SredStIspravakZadnjeStavkeKarticeValidate = SredStIspravakZadnjeStavkeKarticeValidate;
	api.SredStSetAfterPolje = SredStSetAfterPolje;
	api.SredStZamijeniBrojStavke = SredStZamijeniBrojStavke;
	api.SredStPreracunKartice = SredStPreracunKartice;
	api.SredStPresloziKarticu = SredStPresloziKarticu;
	api.SredStKarticaImaPreknjizenje = SredStKarticaImaPreknjizenje;
	api.SredStPromjenaKontaNaKartici = SredStPromjenaKontaNaKartici;
	api.SredStDodajUkloniSredStNaPopisnuListu = SredStDodajUkloniSredStNaPopisnuListu;
	api.SredStProvjeriIspisNaListi = SredStProvjeriIspisNaListi;
	api.SredStRekapPoKontu = SredStRekapPoKontu;
	api.SredStPromjenaPozicijaIzvoriMogucUnosValidate = SredStPromjenaPozicijaIzvoriMogucUnosValidate;
	api.OsobaBySred = OsobaBySred;
	api.SobaByBarkod = SobaByBarkod;
	api.IKnjigaNabDefault = IKnjigaNabDefault;
	api.IRekapKnjDefault = IRekapKnjDefault;
	api.IAktDefault = IAktDefault;
	api.ZgradaById = ZgradaById;
	api.SobaById = SobaById;
	api.LokacijaById = LokacijaById;	
	api.LokacijaPostoji = LokacijaPostoji;
	api.GetOsZaduziFields = GetOsZaduziFields;
	api.GetSredStFields = GetSredStFields;
	api.TipPromById = TipPromById;
	api.TipPromObrisi = TipPromObrisi;
	api.LokacijaObrisi = LokacijaObrisi;
	api.LokacijaMoguceBrisanje = LokacijaMoguceBrisanje;
	api.ZgradaSetAfterPolje = ZgradaSetAfterPolje;
	api.ZgradaMoguceBrisanje = ZgradaMoguceBrisanje;
	api.ZgradaObrisi = ZgradaObrisi;
	api.SobaSetAfterPolje = SobaSetAfterPolje;
	api.SobaMoguceBrisanje = SobaMoguceBrisanje;
	api.SobaObrisi = SobaObrisi;
	api.OsobaSetAfterPolje = OsobaSetAfterPolje;
	api.OsobaMoguceBrisanje = OsobaMoguceBrisanje;
	api.OsobaObrisi = OsobaObrisi;
	api.AmGrupaMoguceBrisanje = AmGrupaMoguceBrisanje;
	api.AmGrupaObrisi = AmGrupaObrisi;
	api.AmGrupaSetAfterPolje = AmGrupaSetAfterPolje;
	api.AmGrupaPitanja = AmGrupaPitanja;
	api.OsGrupaMoguceBrisanje = OsGrupaMoguceBrisanje;
	api.OsGrupaObrisi = OsGrupaObrisi;
	api.OsKontoObrisi = OsKontoObrisi;
	api.GetAzuriranjeShemeKnjizenjaPitanja = GetAzuriranjeShemeKnjizenjaPitanja;
	api.AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara = AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara;
	api.GetAzurirajKarticuSvePitanje = GetAzurirajKarticuSvePitanje;
	api.GetAzurirajKarticuPitanje = GetAzurirajKarticuPitanje;
	api.OsKontoAzurirajKarticu = OsKontoAzurirajKarticu;
	api.OsKontoAzurirajKarticuSve = OsKontoAzurirajKarticuSve;
	api.OsKontoNoviIzvoriVlasnistvaUpis = OsKontoNoviIzvoriVlasnistvaUpis;
	api.OsZaduziSetAfterPolje = OsZaduziSetAfterPolje;
	api.OsOvlastenjeLoadListAfterInven = OsOvlastenjeLoadListAfterInven;
	api.SBInvBrojClick = SBInvBrojClick;
	api.PonovoIzracunajBarKod = PonovoIzracunajBarKod;
	api.SredSetAfterPolje = SredSetAfterPolje;
	api.SredSkObrisi = SredSkObrisi;	
	api.SredSetParamOsnovniPodaci = SredSetParamOsnovniPodaci;		
	api.OsOvlastenjeDeaktiviraj = OsOvlastenjeDeaktiviraj;
	api.AmortizacijaUpisi = AmortizacijaUpisi;
	api.AmortizacijaSetAfterPolje = AmortizacijaSetAfterPolje;
	api.BrojDokumentaGKZadnji = BrojDokumentaGKZadnji;
	api.Revaloriziraj = Revaloriziraj;

    function GetSredStFields() {
        return $.dsDirectCall({ 
			method: "GetSredStFields"
        });
    }

    function GetOsZaduziFields() {
        return $.dsDirectCall({ 
			method: "GetOsZaduziFields" 
        });
    }

	function LokacijaPostoji(lokacija, zgrada, soba){
		return $.dsDirectCallSync({
			method: "LokacijaPostoji",
			params: [ lokacija, zgrada, soba ]
		});
	}
		
	function InvenSObrisi(invens){
		return $.dsDirectCall({
			method: "InvenSObrisi",
			params: [ invens ]
		});
	}
	
	function InvenSPronadeno(invens){
		return $.dsDirectCall({
			method: "InvenSPronadeno",
			params: [ invens ]
		});
	}
	
	function InvenSZaRashod(invens){
		return $.dsDirectCall({
			method: "InvenSZaRashod",
			params: [ invens ]
		});
	}
	
	function InvenSBrojPronadenihZaFilter(invens, osoba){
		return $.dsDirectCall({
			method: "InvenSBrojPronadenihZaFilter",
			params: [ invens, osoba ]
		});
	}
	
	function InvenSPronadenoFilter(invens, osoba){
		return $.dsDirectCall({
			method: "InvenSPronadenoFilter",
			params: [ invens, osoba ]
		});
	}
	
	function SredByBarkod(barkod){
		return $.dsDirectCall({
			method: "SredByBarkod",
			params: [ barkod ]
		});
	}
	
	function SredByInvBroj(invBroj, osSi){
		return $.dsDirectCall({
			method: "SredByInvBroj",
			params: [ invBroj, osSi ]
		});
	}
	
	function OsZaduziById(osZaduzi, lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "OsZaduziById",
			params: [ osZaduzi, lokacija, zgrada, soba]
		});
	}
	
	function SredStById(zSredst){
		return $.dsDirectCall({
			method: "SredStById",
			params: [ zSredst ]
		});
	}
	
	function InvensPostoji(inven, sred, lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "InvensPostoji",
			params: [ inven, sred, lokacija, zgrada, soba ]
		});
	}
	
	function SredById(sred){
		return $.dsDirectCall({
			method: "SredById",
			params: [ sred ]
		});
	}
	
	function SredStIspravakZadnjeStavkeKarticeValidate(sredSt){
		return $.dsDirectCall({
			method: "SredStIspravakZadnjeStavkeKarticeValidate",
			params: [ sredSt ]
		});		
	}
	
	function SredStSetAfterPolje(sredSt, kojePolje, novi){
		return $.dsDirectCallPost({
			method: "SredStSetAfterPolje",
			controller: "sredSt",
			params: [ kojePolje, novi ],
			data: [ sredSt ],
			fail: function (error, textStatus, jqXHR, logicalError){				
			}
		});
	}	
	
	function OsobaBySred(sred){
		return $.dsDirectCall({
			method: "OsobaBySred",
			params: [ sred ]
		});
	}
	
	function SobaByBarkod(barkod){
		return $.dsDirectCall({
			method: "SobaByBarkod",
			params: [ barkod ]
		});
	}
	
	function IKnjigaNabDefault(){
		return $.dsDirectCall({
			method: "IKnjigaNabDefault"
		});
	}
	
	function IRekapKnjDefault(){
		return $.dsDirectCall({
			method: "IRekapKnjDefault"
		});
	}
	
	function IAktDefault(){
		return $.dsDirectCall({
			method: "IAktDefault"
		});
	}
	
	function LokacijaById(lokacija){
		return $.dsDirectCall({
			method: "LokacijaById",
			params: [ lokacija ]
		});
	}

	function ZgradaById(lokacija, zgrada){
		return $.dsDirectCall({
			method: "ZgradaById",
			params: [ lokacija, zgrada ]
		});
	}
	
	function SobaById(lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "SobaById",
			params: [ lokacija, zgrada, soba ]
		});
	}

	function TipPromById(tipprom){
		return $.dsDirectCall({
			method: "TipPromById",
			params: [ tipprom ]
		});
	}
	
	function TipPromObrisi(iTipProm){
		return $.dsDirectCallSync({
			method: "TipPromObrisi",
			params: [ iTipProm ]
		});
	}	
	
	function SredStZamijeniBrojStavke(sredSt1, sredSt2){
		return $.dsDirectCall({
			method: "SredStZamijeniBrojStavke",
			params: [ sredSt1, sredSt2 ]
		});
	}
	
	function SredStPreracunKartice(sred){
		return $.dsDirectCall({
			method: "SredStPreracunKartice",
			params: [ sred ]
		});
	}
	
	function SredStPresloziKarticu(sred){
		return $.dsDirectCall({
			method: "SredStPresloziKarticu",
			params: [ sred ]
		});
	}
	
	function SredStProvjeriIspisNaListi(sredSt){
		return $.dsDirectCall({
			method: "SredStProvjeriIspisNaListi",
			params: [ sredSt ]
		});
	}
	
	function SredStDodajUkloniSredStNaPopisnuListu(sredSt, dodaj){
		return $.dsDirectCall({
			method: "SredStDodajUkloniSredStNaPopisnuListu",
			params: [ sredSt, dodaj ]
		});
	}
	
	function SredStKarticaImaPreknjizenje(sred){
		return $.dsDirectCall({
			method: "SredStKarticaImaPreknjizenje",
			params: [ sred ]
		});
	}
	
	function SredStPromjenaKontaNaKartici(sred){
		return $.dsDirectCall({
			method: "SredStPromjenaKontaNaKartici",
			params: [ sred ]
		});
	}
	
	function SredStRekapPoKontu(sred, datum){		
		return $.dsDirectCall({
			method: "SredStRekapPoKontu",
			params: [ sred, datum ]
		});
	}
	
	function SredStPromjenaPozicijaIzvoriMogucUnosValidate(sredSt){		
		return $.dsDirectCall({
			method: "SredStPromjenaPozicijaIzvoriMogucUnosValidate",
			params: [ sredSt ]
		});
	}
	
	function LokacijaObrisi(lokacija){
		return $.dsDirectCall({
			method: "LokacijaObrisi",
			params: [ lokacija ]
		});
	}
	
	function LokacijaMoguceBrisanje(lokacija){
		return $.dsDirectCall({
			method: "LokacijaMoguceBrisanje",
			params: [ lokacija ]
		});
	}
	
	function ZgradaSetAfterPolje(polje, zgrada, errorOverride){
        return $.dsDirectCallPost({
            method: "ZgradaSetAfterPolje",
            controller: "Zgrada",
			params: [ polje ],
            data: [ zgrada ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function ZgradaMoguceBrisanje(lokacija, zgrada){
		return $.dsDirectCallSync({
			method: "ZgradaMoguceBrisanje",
			params: [ lokacija, zgrada ]
		});
	}
	
	function ZgradaObrisi(lokacija, zgrada){
		return $.dsDirectCallSync({
			method: "ZgradaObrisi",
			params: [ lokacija, zgrada ]
		});
	}
	
	function SobaSetAfterPolje(polje, soba, errorOverride){
        return $.dsDirectCallPost({
            method: "SobaSetAfterPolje",
            controller: "Soba",
			params: [ polje ],
            data: [ soba ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function SobaMoguceBrisanje(lokacija, zgrada, soba){
		return $.dsDirectCallSync({
			method: "SobaMoguceBrisanje",
			params: [ lokacija, zgrada, soba ]
		});
	}
	
	function SobaObrisi(lokacija, zgrada, soba){
		return $.dsDirectCallSync({
			method: "SobaObrisi",
			params: [ lokacija, zgrada, soba ]
		});
	}
	
	function OsobaSetAfterPolje(polje, novi, osoba, errorOverride){
        return $.dsDirectCallPost({
            method: "OsobaSetAfterPolje",
            controller: "Osoba",
			params: [ polje, novi ],
            data: [ osoba ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
	
	function OsobaMoguceBrisanje(osoba){
		return $.dsDirectCallSync({
			method: "OsobaMoguceBrisanje",
			params: [ osoba ]
		});
	}
	
	function OsobaObrisi(osoba){
		return $.dsDirectCallSync({
			method: "OsobaObrisi",
			params: [ osoba ]
		});
	}
	
	function AmGrupaMoguceBrisanje(amGrupa){
		return $.dsDirectCallSync({
			method: "AmGrupaMoguceBrisanje",
			params: [ amGrupa ]
		});
	}
	
	function AmGrupaObrisi(amGrupa){
		return $.dsDirectCallSync({
			method: "AmGrupaObrisi",
			params: [ amGrupa ]
		});
	}
	
	function AmGrupaSetAfterPolje(polje, novi, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmGrupaSetAfterPolje",
            controller: "AmGrupa",
			params: [ polje, novi ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
       
   	function AmGrupaPitanja(amGrupaS, amGrupaN){
		return $.dsDirectCallSync({
			method: "AmGrupaPitanja",
			params: [ amGrupaS, amGrupaN ]
		});
	}
	
	function OsGrupaMoguceBrisanje(osGrupa){
		return $.dsDirectCallSync({
			method: "OsGrupaMoguceBrisanje",
			params: [ osGrupa ]
		});
	}
	
	function OsGrupaObrisi(osGrupa){
		return $.dsDirectCallSync({
			method: "OsGrupaObrisi",
			params: [ osGrupa ]
		});
	}
	
	function OsKontoObrisi(osKonto){
		return $.dsDirectCall({
			method: "OsKontoObrisi",
			params: [osKonto],
		});
	}
		
	function GetAzuriranjeShemeKnjizenjaPitanja(osKonto){
		return $.dsDirectCall({
			method: "GetAzuriranjeShemeKnjizenjaPitanja",
		});
	}
	
	function AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara(osKonto){
		return $.dsDirectCall({
			method: "AzuriranjeShemeKnjizenjaPremaStanjuNaKaricamaInventara",
		});
	}
	
	function GetAzurirajKarticuSvePitanje(){
		return $.dsDirectCall({
			method: "GetAzurirajKarticuSvePitanje",
		});
	}
	
	function GetAzurirajKarticuPitanje(osKonto){
		return $.dsDirectCall({
			method: "GetAzurirajKarticuPitanje",
			params: [osKonto]
		});
	}
	
	function OsKontoAzurirajKarticu(osKontoList){
		return $.dsDirectCall({
			method: "OsKontoAzurirajKarticu",
			params: [ osKontoList ]
		});	
	}
	
	function OsKontoAzurirajKarticuSve(filt){
		return $.dsDirectCall({
			method: "OsKontoAzurirajKarticu",
			params: [ filt ]
		});	
	}

	function OsKontoNoviIzvoriVlasnistvaUpis(osKontoList, izvori){
		return $.dsDirectCall({
			method: "OsKontoNoviIzvoriVlasnistvaUpis",
			params: [ osKontoList, izvori ]
		});	
	}
	
	function OsZaduziSetAfterPolje(polje, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "OsZaduziSetAfterPolje",
            controller: "OsZaduzi",
			params: [ polje ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function OsOvlastenjeLoadListAfterInven(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "OsOvlastenjeLoadListAfterInven",
            controller: "OsOvlastenje",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function SBInvBrojClick(invBroj, ossi){
		return $.dsDirectCallSync({
			method: "SBInvBrojClick",
			params: [ invBroj, ossi ]
		});
	}
	
	function PonovoIzracunajBarKod(invBroj, osGrupa, ossi){
		return $.dsDirectCallSync({
			method: "PonovoIzracunajBarKod",
			params: [ invBroj, osGrupa, ossi ]
		});
	}	
	
	function SredSetAfterPolje(polje, novi, objects, errorOverride){
        return $.dsDirectCallPost({
            method: "SredSetAfterPolje",
            controller: "Sred",
			params: [ polje, novi ],
            data: [ objects ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function SredSkObrisi(sredSk, osSi){
		return $.dsDirectCallSync({
			method: "SredSkObrisi",
			params: [ sredSk, osSi ]
		});
	}

	function SredSetParamOsnovniPodaci(prikaziOsnovnePodatke, prikaziSadasnjuVrijednost){
		return $.dsDirectCallSync({
			method: "SredSetParamOsnovniPodaci",
			params: [ prikaziOsnovnePodatke, prikaziSadasnjuVrijednost ]
		});
	}	
	
	function OsOvlastenjeDeaktiviraj(listaOvlastenja, errorOverride){
        return $.dsDirectCall({
            method: "OsOvlastenjeDeaktiviraj",
			params: [ listaOvlastenja ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function AmortizacijaUpisi(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmortizacijaUpisi",
            controller: "Amortizacija",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }	

	function AmortizacijaSetAfterPolje(polje, obj, errorOverride){
        return $.dsDirectCallPost({
            method: "AmortizacijaSetAfterPolje",
            controller: "Amortizacija",
			params: [ polje ],
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    
	function BrojDokumentaGKZadnji(dokum){
		return $.dsDirectCallSync({
			method: "BrojDokumentaGKZadnji",
			params: [ dokum ]
		});
	}
	
	function Revaloriziraj(obj, errorOverride){
        return $.dsDirectCallPost({
            method: "revaloSubmit",
            controller: "Revalo",
            data: [ obj ],
            fail: function (error, textStatus, jqXHR, logicalError){
				KUtils.busy(false); 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }
    	

} (konto.os.api = {}));